export const iconsFeature = {
  'icon-tv-nuevo': 'Tv',
  'icon-movil-nuevo': 'Movil',
  'icon-sim-nuevo': 'Sim',
  'icon-fibra-nuevo': 'Fibra',
  'icon-multicontenido': 'Multicontenido',
  'icon-informacion': 'Informacion',
  
};
